(function($, root, undefined) {

    function formatEUR(cents) {
    return (cents / 100).toLocaleString("de-DE", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + " €";
  }

  $(function() {
    // Handlebar Format
    Handlebars.registerHelper('iff', function (a, operator, b, opts) {
      let bool = false;
      switch (operator) {
        case '===':
          bool = a === b;
          break;
        case '>':
          bool = a > b;
          break;
        case '<':
          bool = a < b;
          break;
        default:
          bool = a === b;
      }
   
      if (bool) {
        return opts.fn(this);
      }
      return opts.inverse(this);
    });

    //-------------------------
    //-- Builder Start Page --
    //-------------------------
    //testimonial_slider();
    $(".btn.start-btn").click(function(e){
      e.preventDefault();
      $(".regime-landing").addClass("hide");
      $(".regime-page").removeClass("hide");
    });

    //------------------
    //-- Regime Page --
    //------------------
    //Name Field ( Step 1 )
    var cust_name = '';
    $('#customer-name').on('keyup', function (e) {
      cust_name = $(this).val().charAt(0).toUpperCase() + $(this).val().slice(1);
      $("h2.step-title .name").text(cust_name);
    });

    // Get All needed products data here
    var selected_product_index = 0,
        hero_product_id = 0,
        hero_product_fid = 0,
        hero_product_handle = '',
        gift_product_id = '',
        gift_product_handle = '',
        gift_product_sup = '',
        gift_product_exce = '',
        recom_products_data = [],
        rec_product_handles = '',
        rec_product_ids = '',
        all_rec_product_ids = '',
        all_rec_product_ids_arr = [],
        rec_product_handles_arr = [],
        rec_product_ids_arr = [],
        cus_gift_pur = true;

    //Next Button
    $(".step-buttons .next-btn").click(function(){
      var current_step = $(".regime-steps .single-step.active").data("id");      
      var next_step = "0" + (parseInt(current_step) + 1);
      
      var valid = validate_current_step(current_step);

      if(current_step === '07'){

        if(valid){
          $('.regime-steps .single-step[data-id="'+ current_step +'"]').removeClass("active");
          $('.regime-steps .single-step[data-id="07-1"]').addClass("active");
          $(".regime-footer .step-teller").addClass("hide");
        }

        return;
      }

      if(current_step === '07-1'){
        $('.regime-steps .single-step[data-id="'+ current_step +'"]').removeClass("active");
        $('.regime-steps .single-step[data-id="'+ next_step +'"]').addClass("active");
        step_bar_update(next_step);
        step_tooltip_update(next_step);
        scroll_to_anchor("regime-anchor");

        return;
      }

      if(current_step === '08'){
        if(valid){
          $('.regime-steps .single-step[data-id="'+ current_step +'"]').removeClass("active");
          $('.regime-steps .single-step[data-id="08-1"]').addClass("active");

          // Step 8 Contiue Step Comment Slider
          treebrain_comments_slider();

          $(".regime-header").addClass("hide");
          $(".regime-footer .step-teller").addClass("hide");
          $("#shopify-section-step-buttons .step-buttons").addClass("hide");

          setTimeout(function(){
            $('.regime-steps .single-step[data-id="08-1"]').removeClass("active");
            $('.regime-steps .single-step[data-id="'+ next_step +'"]').addClass("active");

            step_bar_update(next_step);
            step_tooltip_update(next_step);
            scroll_to_anchor("regime-anchor");

            $(".regime-header").removeClass("hide");
            $(".regime-footer .step-teller").removeClass("hide");
            $("#shopify-section-step-buttons .step-buttons").removeClass("hide");

            treebrain_comments_slider_destroy();
          }, 3000);        
        }
        return;
      }
      
      if(valid){
        $('.regime-steps .single-step[data-id="'+ current_step +'"]').removeClass("active");
        $('.regime-steps .single-step[data-id="'+ next_step +'"]').addClass("active");
        
        step_bar_update(next_step);
        step_tooltip_update(next_step);
        scroll_to_anchor("regime-anchor");
        
        if(next_step === '010'){

          $(".regime-footer .step-teller").addClass("hide");
          
          //Choose a hero product matching conditions
          var all_products_json = JSON.parse($("#all_products_json").html());
          var selected_cond = [];
              selected_cond[0] = [];
              selected_cond[1] = [];
          var step_6_val = [], step6_inside_pr_option = true;

          for (var i = 0; i < 2; i++) {
            var step_num_txt = i + 2;

            $('.regime-steps .single-step[data-id="0' + step_num_txt + '"] .step-items ul.select-list li')
              .each(function () {
                if ($(this).hasClass("selected")) {
                  // Prefer stable mapping across languages:
                  // add data-cond="1" / "2" / ... to each <li> in the HTML on BOTH pages
                  var cond = $(this).data("cond");

                  // Fallback if data-cond isn't present yet:
                  if (cond == null) cond = $(this).index() + 1;

                  selected_cond[i].push(String(cond));
                }
              });
          }
          // ===== DEBUG: what did we capture from the UI? =====
console.group("[REGIME DEBUG] Selected conditions");
console.log("URL:", window.location.href);
console.log("Step2 selected_cond[0]:", selected_cond[0]);
console.log("Step3 selected_cond[1]:", selected_cond[1]);

console.log("Step2 selected LI:", $('.regime-steps .single-step[data-id="02"] .select-list li.selected')
  .map((idx, el) => ({ text: $(el).text().trim(), cond: $(el).data("cond"), index: $(el).index() + 1 }))
  .get()
);

console.log("Step3 selected LI:", $('.regime-steps .single-step[data-id="03"] .select-list li.selected')
  .map((idx, el) => ({ text: $(el).text().trim(), cond: $(el).data("cond"), index: $(el).index() + 1 }))
  .get()
);
console.groupEnd();



          $('.regime-steps .single-step[data-id="06"] .step-items ul.select-list li').each(function(index, elem){
            if($(this).hasClass("selected")){
              step_6_val.push('' + (parseInt(index) + 1) + '');
            }
          });

          if(step_6_val.length > 0){
            if(step_6_val.indexOf('7') > -1) step6_inside_pr_option = false;
          }
         
          selected_product_index = 0; // fallback

selected_product_index = 0; // fallback

if (all_products_json.length > 0) {
  // ===== DEBUG: show available mappings =====
  console.group("[REGIME DEBUG] all_products_json");
  console.log("all_products_json length:", all_products_json.length);
  console.log("product_cond list:", all_products_json.map(p => p.product_cond));
  console.groupEnd();

  // ===== DEBUG: find all matches =====
  var _matches = [];
  for (var mi = 0; mi < all_products_json.length; mi++) {
    var _cond = (all_products_json[mi].product_cond || "").toString().replace(".", ",").split(",");

    if (_cond.length !== 2) continue;

    var _ok =
      selected_cond[0].indexOf(String(_cond[0])) > -1 &&
      selected_cond[1].indexOf(String(_cond[1])) > -1;

    if (_ok) {
      _matches.push({
        i: mi,
        product_cond: all_products_json[mi].product_cond,
        hero: all_products_json[mi].hero_product_handle,
        gift: all_products_json[mi].gift_product_handle
      });
    }
  }
  console.group("[REGIME DEBUG] Matches");
  console.log("matches:", _matches);
  console.groupEnd();

  // ===== CHOOSE the first match (THIS WAS MISSING) =====
  for (var i = 0; i < all_products_json.length; i++) {
    var s_cond = (all_products_json[i].product_cond || "").toString().replace(".", ",");

    var s_cond_arr = s_cond.split(",");
    if (s_cond_arr.length !== 2) continue;

    var ok =
      selected_cond[0].indexOf(String(s_cond_arr[0])) > -1 &&
      selected_cond[1].indexOf(String(s_cond_arr[1])) > -1;

    if (ok) {
      selected_product_index = i;
      break;
    }
  }
  console.log("[REGIME DEBUG] selected_product_index picked:", selected_product_index);

  // ===== Apply the chosen mapping =====
  hero_product_id = all_products_json[selected_product_index].hero_product_id;
  hero_product_handle = all_products_json[selected_product_index].hero_product_handle;
  gift_product_id = all_products_json[selected_product_index].gift_product_id;
  gift_product_handle = all_products_json[selected_product_index].gift_product_handle;
  gift_product_exce = all_products_json[selected_product_index].gift_product_exce;
  recom_products_data = all_products_json[selected_product_index].recommend_products;

  console.group("[REGIME DEBUG] Chosen mapping");
  console.log("chosen product_cond:", all_products_json[selected_product_index]?.product_cond);
  console.log("hero_product_handle:", hero_product_handle);
  console.log("gift_product_handle:", gift_product_handle);
  console.groupEnd();



          // Get the current date
          const currentDate = new Date();
          const cutoffDate = new Date(currentDate.getFullYear(), 1, 1, 0, 0, 0); // Feb 1, 12:00 AM
          
          // Define the variables
          var gift_product_handle = "1-x-f59f59-corrective-serum-face-olive-brain-gift-for-retail-customers";
          var gift_product_id = "57049817219445"; // delete
          

            console.log("gift_product_id:", gift_product_id);
                  console.log("gift_product_handle: ", gift_product_handle);

            if(gift_product_handle.includes("f09")){
              gift_product_sup = 'f64';
            } else {
              gift_product_sup = 'f64'; //Change back to f64 delete
            }

            if(recom_products_data){
              rec_product_handles = recom_products_data.products_handles;
              rec_product_handles_arr = rec_product_handles.split(",");
              rec_product_ids = recom_products_data.product_ids;
              rec_product_ids_arr = rec_product_ids.split(",");

              rec_product_avails = recom_products_data.product_avail;
              rec_product_avails_arr = rec_product_avails.split(",");

              console.log("rec_product_avails_arr => ", rec_product_avails_arr);
              console.log("rec_product_ids_arr => ", rec_product_ids_arr);

              // Decide whether to exclude Inside Products or not
              if(!step6_inside_pr_option){
                for (var k = 0; k < rec_product_ids_arr.length; k++) {
                  if(rec_product_handles_arr[k].charAt(0) === "i"){
                    rec_product_handles_arr.splice(k, 1);
                    rec_product_ids_arr.splice(k, 1);
                    rec_product_avails_arr.splice(k, 1);
                  }
                }
              }

              // Remove not available products
              for (var m = 0; m < rec_product_avails_arr.length; m++) {
                if(rec_product_avails_arr[m] == "false" || rec_product_avails_arr[m] == false){
                  //rec_product_handles_arr.splice(m, 1);
                  rec_product_ids_arr.splice(m, 1);
                }
              }

              console.log("rec_product_ids_arr => ", rec_product_ids_arr);
              
              all_rec_product_ids = gift_product_id + "," + rec_product_ids_arr.join(',');
            }
          }          

          if(hero_product_handle == '') hero_product_handle = 'f65-midnight-gesichtselixier-hydroxytyrosol-corrective';
          
          $(".regime-header").addClass("hide");
          $(".regime-body .regime-steps").addClass("hide");
          $(".step-buttons").addClass("hide");

          $("#shopify-section-regime-trybefore").removeClass("hide");
          $(".regime-bottom").removeClass("hide");
          
          var rec_metas = JSON.parse($("#products_meta_json").html());
          var currency_iso_code = $(".all-products-cart-btn").data("curr-isocode");
          var hero_source = document.getElementById("regime-result-hero-template").innerHTML;
          var hero_template = Handlebars.compile(hero_source);

          jQuery.getJSON('/products/' + hero_product_handle + '.js', function (hero_product) {
            var hero_product_variant = [],
                hero_info_prefix = '',
                hero_info_primarytitle = '',
                hero_info_secondarytitle = '';

            hero_product_fid = hero_product.variants[0].id;

            if(rec_product_ids_arr.length > 0){
              all_rec_product_ids = all_rec_product_ids + "," + hero_product.variants[0].id;

              all_rec_product_ids_arr = all_rec_product_ids.split(",");
              all_rec_product_ids_arr = removeDuplicates(all_rec_product_ids_arr);
            }

            for (var j = 0; j < rec_metas.length; j++) {
              if(rec_metas[j].p_handle == hero_product.handle){
                hero_info_prefix = rec_metas[j].info_prefix;
                hero_info_primarytitle = rec_metas[j].info_primarytitle;
                hero_info_secondarytitle = rec_metas[j].info_secondarytitle;
              }
            }

            var unit_price_measurement_value = '',
                unit_price_measurement_unit = '',
                unit_price = '',
                unit_price_reference_value = '',
                unit_price_base_unit = '';
            
            if(hero_product.variants[0].unit_price){
              unit_price =  formatEUR(hero_product.variants[0].unit_price);
            }
            if(hero_product.variants[0].unit_price_measurement){

              if(hero_product.variants[0].unit_price_measurement.quantity_value){
                unit_price_measurement_value_arr = hero_product.variants[0].unit_price_measurement.quantity_value.split(".");
                unit_price_measurement_value = unit_price_measurement_value_arr[0];
              }
              if (hero_product.variants[0].unit_price_measurement.quantity_unit) {
                unit_price_measurement_unit = hero_product.variants[0].unit_price_measurement.quantity_unit; // "ml"
              } else if (hero_product.variants[0].unit_price_measurement.reference_unit) {
                unit_price_measurement_unit = hero_product.variants[0].unit_price_measurement.reference_unit; // fallback
              }

              if(hero_product.variants[0].unit_price_measurement.reference_value != 1){
                unit_price_reference_value = hero_product.variants[0].unit_price_measurement.reference_value;
              }
            }
            unit_price_base_unit = '<span data-unit-price-base-unit>' + unit_price_reference_value + unit_price_measurement_unit + '</span>';

            var current_variant_qty = 0;
            if(hero_product.variants[0].available) current_variant_qty = 100;

            var data = hero_template({
              product_id: hero_product.id,
              product_images: hero_product.images,
              product_prefix: hero_info_prefix,
              product_primary_title: hero_info_primarytitle,
              product_secondarytitle: hero_info_secondarytitle,
              product_description: hero_product.description,
              current_variant : {
                available: hero_product.variants[0].available,
                product_price: formatEUR(hero_product.variants[0].price),
                unit_price_measurement_value: unit_price_measurement_value,
                unit_price_measurement_unit: unit_price_measurement_unit,
                unit_price: unit_price,
                id: hero_product.variants[0].id,
                unit_price_base_unit: unit_price_base_unit,
                current_variant_qty: current_variant_qty
              },
              gift_product_id: gift_product_id
            });

            $("#shopify-section-regime-result").addClass("active");
            $('#result-hero-product-area').append(data);

            $("#result-hero-product .product-images").slick({
              infinite: true,
              fade: true,
              speed: 1000,
              slidesToShow: 1,
              slidesToScroll: 1,
              autoplay: false,
              dots: true,
              prevArrow: '<span class="left-arrow"><svg width="34" height="27" viewBox="0 0 34 27" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="32" y1="13.4956" x2="4" y2="13.4956" stroke="black" stroke-width="2" stroke-linecap="square"/><path d="M14 1.49561L2 13.2484L14 25.4956" stroke="black" stroke-width="2"/></svg></span>',
              nextArrow: '<span class="right-arrow"><svg width="34" height="26" viewBox="0 0 34 26" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="2" y1="13" x2="30" y2="13" stroke="black" stroke-width="2" stroke-linecap="square"/><path d="M20 25L32 13.2472L20 1" stroke="black" stroke-width="2"/></svg></span>'
            });
          });

          // Gift Product Section
          if(gift_product_handle != "" ){
            jQuery.getJSON('/products/' + gift_product_handle + '.js', function (product) {
              
              $("#result-gift-product .gift-box .product-img img").attr("src", product.featured_image);
              $("#result-gift-product .gift-product-details .product-title").text(product.title);
              $("#result-gift-product .gift-product-details .product-desc").text(gift_product_exce);
              $("#result-gift-product .gift-product-details .product-price").text(formatEUR(product.variants[0].price));
              $("#result-gift-product-form").attr("onsubmit", "CartHelper.addToCart(event,"+ product.variants[0].id +",100,'"+ currency_iso_code +"', {'brain_product': true,'brain_gift_id': "+ product.variants[0].id +" })");
            });
          }
        if (isConsultant) {
          var giftProductElement = document.getElementById("result-gift-product");
          var giftOfferTextElement = document.getElementById("giftOfferText");
        
          if (giftProductElement) {
            giftProductElement.style.display = "none";
          }
        
          if (giftOfferTextElement) {
            giftOfferTextElement.style.display = "none";
          }
        }

          //Choose recommendation Products matching conditions given
          var rec_source = document.getElementById("regime-result-rec-product-template").innerHTML;
          var rec_template = Handlebars.compile(rec_source);

          if(rec_product_handles_arr.length > 0){
            for (var i = 0; i < rec_product_handles_arr.length; i++) {
              var single_p_handle = rec_product_handles_arr[i];

              if(single_p_handle != ""){                

                jQuery.getJSON('/products/' + single_p_handle + '.js', function (product) {

                  var product_variants = [],
                      product_box_title = '', 
                      application_type ='',
                      info_prefix = '',
                      info_primarytitle = '',
                      info_secondarytitle = '',
                      info_excerpt = '';

                  switch(product.handle){
                    case "f38-reinigungsgel-purifying":
                      product_box_title= "type1";
                      application_type= "morgens_abends";
                      break;
                    case "f71-reinigungsgel-hydroxytyrosol-corrective":
                      product_box_title= "type1";
                      application_type= "morgens_abends";
                      break;
                    case "f72-reinigungsol-hydroxytyrosol-corrective":
                      product_box_title= "type2";
                      application_type= "morgens_abends";
                      break;
                    case "f78-arbequina-reinigungsol":
                      product_box_title= "type2";
                      application_type= "morgens_abends";
                      break;
                    case "f11-facial-toner":
                      product_box_title= "f11-facial-toner";
                      application_type= "morgens_abends";
                      break;
                    case "f67-hydroxytyrosol-corrective-facial-tonic":
                      product_box_title= "f67-hydroxytyrosol-corrective-facial-tonic";
                      application_type= "morgens_abends";
                      break;
                    case "f10-face-peeling-olive-core":
                      product_box_title= "f10-face-peeling-olive-core";
                      application_type= "2Woche";
                      break;
                    case "f18-black-olive-face-mask":
                      product_box_title= "f18-black-olive-face-mask";
                      application_type= "2Woche";
                      break;
                    case "f77-olive-matcha-face-mask":
                      product_box_title= "f77-olive-matcha-face-mask";
                      application_type= "2Woche";
                      break;
                    case "f76-honey-enzyme-face-mask":
                      product_box_title= "f76-honey-enzyme-face-mask";
                      application_type= "2Woche";
                      break;
                    case "f06-serum-face-cell-active":
                      product_box_title= "f06-serum-face-cell-active";
                      application_type= "morgens_abends";
                      break;  
                    case "f59-hydroxytyrosol-corrective-serum-face":
                      product_box_title= "f59-hydroxytyrosol-corrective-serum-face";
                      application_type= "morgens_abends";
                      break;
                    case "f63-gesichtsol-cell-active":
                      product_box_title= "type10";
                      application_type= "morgens_abends";
                      break;
                    case "f82-green-retinol-face-elixir":
                      product_box_title= "type10";
                      application_type= "morgens_abends";
                      break;
                    case "f05-face-cream-anti-oxidant":
                      product_box_title= "f05-face-cream-anti-oxidant";
                      application_type= "morgens_abends";
                      break;
                    case "f07-face-cream-anti-aging":
                      product_box_title= "type11";
                      application_type= "morgens_abends";
                      break;
                    case "f08-face-cream-cell-active":
                      product_box_title= "type11";
                      application_type= "morgens_abends";
                      break;
                    case "f42-hydroxytyrosol-corrective-face-cream":
                      product_box_title= "f42-hydroxytyrosol-corrective-face-cream";
                      application_type= "morgens_abends";
                      break;
                    case "f74-regeneration-intense-face-cream":
                      product_box_title= "f74-regeneration-intense-face-cream";
                      application_type= "morgens_abends";
                      break;
                    case "f09-augencreme-anti-wrinkle":
                      product_box_title= "type11";
                      application_type= "morgens_abends";
                      break;
                    case "f60-hydroxytyrosol-corrective-eye-cream":
                      product_box_title= "f60-hydroxytyrosol-corrective-eye-cream";
                      application_type= "morgens_abends";
                      break;
                    case "i66-the-beauty-fountain":
                      product_box_title= "type12";
                      application_type= "morgens_oder_abends";
                      break;
                    case "i70-the-beauty-molecule":
                      product_box_title= "type13";
                      application_type= "morgens_oder_abends";
                      break;
                    case "f81-aha-ht-serum-face":
                      product_box_title= "type14";
                      application_type= "abends-ersetzt";
                      break;
                    default:
                      product_box_title= "type1";
                      application_type= "morgens_abends";
                      break;                
                  }

                  for (var j = 0; j < rec_metas.length; j++) {
                    if(rec_metas[j].p_handle == product.handle){
                      info_prefix = rec_metas[j].info_prefix;
                      info_primarytitle = rec_metas[j].info_primarytitle;
                      info_secondarytitle = rec_metas[j].info_secondarytitle;
                      info_excerpt = rec_metas[j].info_excerpt;
                    }
                  }

                  $.each(product.variants, function(k,v){
                    var single_variant = {
                      available: v.available,
                      id: v.id,
                      title: v.title,
                      price: v.price,
                      price_format: formatEUR(v.price)
                    }
                    product_variants.push(single_variant);
                  });

                  var unit_price_measurement_value = '',
                      unit_price_measurement_unit = '',
                      unit_price = '',
                      unit_price_reference_value = '',
                      unit_price_base_unit = '';
                  
                  if(product.variants[0].unit_price){
                    unit_price = formatEUR(product.variants[0].unit_price);
                  }
                  if(product.variants[0].unit_price_measurement){

                    if(product.variants[0].unit_price_measurement.quantity_value){
                      unit_price_measurement_value_arr = product.variants[0].unit_price_measurement.quantity_value.split(".");
                      unit_price_measurement_value = unit_price_measurement_value_arr[0];
                    }
                    if (product.variants[0].unit_price_measurement.quantity_unit) {
                      unit_price_measurement_unit = product.variants[0].unit_price_measurement.quantity_unit; // ml
                    } else if (product.variants[0].unit_price_measurement.reference_unit) {
                      unit_price_measurement_unit = product.variants[0].unit_price_measurement.reference_unit; // fallback
                    }

                    if(product.variants[0].unit_price_measurement.reference_value != 1){
                      unit_price_reference_value = product.variants[0].unit_price_measurement.reference_value;
                    }
                  }
                  unit_price_base_unit = '<span data-unit-price-base-unit>' + unit_price_reference_value + unit_price_measurement_unit + '</span>';

                  var current_variant_qty = 0;
                  if(product.variants[0].available) current_variant_qty = 100;

                 var isSpanish = false;
if (sessionStorage.getItem('otpLang') === 'es') {
  isSpanish = true;
}

if (product.metafields) {
  // Log all keys within product.metafields
  console.log('Product Metafields Keys:', Object.keys(product.metafields));
  console.log('Product Metafields:', product.metafields); // Full details

  // Check if the required Spanish fields are available
  console.log('Info Excerpt ES:', product.metafields.info_excerpt_es);
  console.log('Info Excerpt EN:', product.metafields.info_excerpt);
} else {
  console.log('No metafields available on product.');
}
                  
// Safeguard: Check if product.metafields exists before accessing keys
var info_prefix = isSpanish && product.metafields && product.metafields.info_prefix_es ? product.metafields.info_prefix_es : product.metafields?.info_prefix;
var info_primarytitle = isSpanish && product.metafields && product.metafields.info_primarytitle_es ? product.metafields.info_primarytitle_es : product.metafields?.info_primarytitle;
var info_secondarytitle = isSpanish && product.metafields && product.metafields.info_secondarytitle_es ? product.metafields.info_secondarytitle_es : product.metafields?.info_secondarytitle;
//var info_excerpt = isSpanish && product.metafields && product.metafields.info_excerpt_es ? product.metafields.info_excerpt_es : product.metafields && product.metafields.info_excerpt;

var data = rec_template({
  product_id: product.id,
  product_box_title: product_box_title,
  application_type: application_type,
  product_fimg: product.featured_image,
  phero_images: product.images,
  product_images_size: product.images.length,
  product_metafields_info_prefix: info_prefix,
  product_metafields_info_primarytitle: info_primarytitle,
  product_metafields_info_secondarytitle: info_secondarytitle,
  product_metafields_info_excerpt: info_excerpt,
  product_link: product.url,
  product_has_only_default_variant: true,
  current_variant: {
    available: product.variants[0].available,
    compare_at_price: product.variants[0].compare_at_price,
    inventory_quantity: current_variant_qty,
    sku: product.variants[0].sku,
    id: product.variants[0].id,
    product_price: formatEUR(product.variants[0].price),
    unit_price_measurement_value: unit_price_measurement_value,
    unit_price_measurement_unit: unit_price_measurement_unit,
    unit_price: unit_price,
    unit_price_base_unit: unit_price_base_unit,
  },
  product_variants: product_variants,
  gift_product_id: gift_product_id
});



                  $('.result-recommendation-products').append(data);

                  if($(".regime-result .action-buttons").hasClass("hide")){
                    $(".regime-result .action-buttons").removeClass("hide");
                  }
                    
                  //Regime Review Section
                  if($("#shopify-section-regime-result-review .before-after").length <= 0){
                    var regime_rev_source = document.getElementById("regime-review-before-after-template").innerHTML;
                    var regime_rev_template = Handlebars.compile(regime_rev_source);
                    
                    $('#shopify-section-regime-result-review').append(regime_rev_template());
                    //Before and After Image Slider
                    $(".before-after .before-after-slider").slick({
                      infinite: true,
                      fade: true,
                      speed: 1000,
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      autoplay: true,
                      autoplaySpeed: 5000,
                      dots: false,
                      prevArrow: '<span class="left-arrow"><svg width="34" height="27" viewBox="0 0 34 27" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="32" y1="13.4954" x2="4" y2="13.4954" stroke="#ABABAB" stroke-width="2" stroke-linecap="square"/><path d="M14 1.49536L2 13.2482L14 25.4954" stroke="#ABABAB" stroke-width="2"/></svg></span>',
                      nextArrow: '<span class="right-arrow"><svg width="34" height="27" viewBox="0 0 34 27" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="2" y1="13.4954" x2="30" y2="13.4954" stroke="#ABABAB" stroke-width="2" stroke-linecap="square"/><path d="M20 25.4954L32 13.7425L20 1.49536" stroke="#ABABAB" stroke-width="2"/></svg></span>',
                      responsive: [{
                        breakpoint: 568,
                        settings: {
                          arrows: false,
                          dots: true
                        }
                      }]
                    });
                  }

                  //Display Hero Out of Stock Status
  updateButtonStyles();
  updateSpanText();
      
                  //Regime Testimonials Section
                  if($("#regime-result-testimonials-section .regime-testimonial-content").length <= 0){
                    var regime_testimonials_source = document.getElementById("regime-testimonials-template").innerHTML;
                    var regime_testimonials_template = Handlebars.compile(regime_testimonials_source);
                    
                    $('#regime-result-testimonials-section').append(regime_testimonials_template());
                    
                    $("#regime-result-testimonials-section .regime-testimonial-list .testimonials-list").slick({
                      fade: true,
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      autoplay: false,
                      touchMove: false,
                      focusOnSelect: true,
                      dots: true,
                      arrows: true,
                      appendArrows: $(".slider-meta .slider-arrows"),
                      prevArrow: '<span class="left-arrow"><svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.44531 10.2913L1.00087 5.64559L5.44531 0.999924" stroke="#787878"/></svg></span>',
                      nextArrow: '<span class="right-arrow"><svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 10.2913L5.44444 5.64559L1 0.999924" stroke="#787878"/></svg></span>',
                      appendDots: $(".slider-meta .slider-pagin"),
                      customPaging: function(slick, index) {
                        return '<a>' + (index + 1) + '</a>';
                      }
                    });                    
                  }                    
                });
              }
            }
          }

          // Send Email with Result Products
          setTimeout(email_result_products, 3000);

          // Check if a customer purchased a free gift products before
          var cus_gift = {
            email: $("#customer-email").val()
          }

          var cusrequest = $.ajax({
            url: "https://ground.connectolive.com/olivedia-regime-builder/customer-order-us.php",
            type: "post",
            data: cus_gift,
            dataType: "text",
          });

          cusrequest.done(function (response, textStatus, jqXHR){
            cus_gift_pur = response;

            if(!cus_gift_pur){
              all_rec_product_ids_arr.shift();
              jQuery("#result-gift-product .gift-content .gift-product-details").append("<p class='no-gift-notice'>You already purchased this Gift.</p>")
            }
            all_rec_product_ids = all_rec_product_ids_arr.join(',');
            $("#all-products-ids").val(all_rec_product_ids);
            $("[data-multi-products-addtocart]").attr("onclick", "CartHelper.addToMultiItemsCart(event, '"+ currency_iso_code +"', ["+ all_rec_product_ids +"], "+ gift_product_id +")");
          });

          cusrequest.fail(function (jqXHR, textStatus, errorThrown){
            console.error(
              "The following error occurred: "+
              textStatus, errorThrown
            );
          });
        }
      }
    });
    
    //Back Button
    $(".step-buttons .prev-btn").click(function(){
      var current_step = $(".regime-steps .single-step.active").data("id");
      var prev_step_num = parseInt(current_step) - 1;
      var prev_step = "0" + prev_step_num;
      
      if(prev_step_num == 0) {
        // $(".regime-landing").removeClass("hide");
        // $(".regime-page").addClass("hide");
        window.location.href = '/pages/olive-brain-regime';
        return;
      }

      if(current_step === '07-1'){
        $('.regime-steps .single-step[data-id="'+ current_step +'"]').removeClass("active");
        $('.regime-steps .single-step[data-id="07"]').addClass("active");
        
        step_tooltip_update("07");
        scroll_to_anchor("regime-anchor");

        return;
      }

      if(current_step === '08'){
        $('.regime-steps .single-step[data-id="'+ current_step +'"]').removeClass("active");
        $('.regime-steps .single-step[data-id="07-1"]').addClass("active");
        step_bar_update(prev_step);
        $(".regime-footer .step-teller").addClass("hide");
        scroll_to_anchor("regime-anchor");

        return;
      }

      if(current_step === '09'){
        $('.regime-steps .single-step[data-id="'+ current_step +'"]').removeClass("active");
        $('.regime-steps .single-step[data-id="08-1"]').addClass("active");

        // Step 8 Contiue Step Comment Slider
        treebrain_comments_slider();

        $(".regime-header").addClass("hide");
        $(".regime-footer .step-teller").addClass("hide");
        $("#shopify-section-step-buttons .step-buttons").addClass("hide");

        setTimeout(function(){
          $('.regime-steps .single-step[data-id="08-1"]').removeClass("active");
          $('.regime-steps .single-step[data-id="'+ prev_step +'"]').addClass("active");

          step_bar_update(prev_step);
          step_tooltip_update(prev_step);
          scroll_to_anchor("regime-anchor");

          $(".regime-header").removeClass("hide");
          $(".regime-footer .step-teller").removeClass("hide");
          $("#shopify-section-step-buttons .step-buttons").removeClass("hide");

          treebrain_comments_slider_destroy();
        }, 3000);

        return;
      }
      
      $('.regime-steps .single-step[data-id="'+ current_step +'"]').removeClass("active");
      $('.regime-steps .single-step[data-id="'+ prev_step +'"]').addClass("active");
      
      step_bar_update(prev_step);
      step_tooltip_update(prev_step);
      scroll_to_anchor("regime-anchor");
      
    });

    // Step Form Items Clicking
    $(".step-items ul.select-list li").click(function(){
      var limit_num = 0,
          select_limit = $(this).parent().data("limit") ? $(this).parent().data("limit") : 100;
      
      $(this).parent().children().each(function(index,element){
        if($(element).hasClass("selected")){
          limit_num++;
        }
      });

      if($(this).closest(".single-step").data("id") === "06" && $(this).is(":last-child")){ // Last Child of 06 Step
        if($(this).hasClass("selected")){
          $(this).removeClass("selected");
          limit_num--;
        } else {
          limit_num++;
          $(this).parent().children().removeClass("selected");
          $(this).addClass("selected");
        }
      } else {
        if($(this).hasClass("selected")){
          $(this).removeClass("selected");
          limit_num--;
        } else {
          if(limit_num < select_limit) {
            $(this).addClass("selected");
            limit_num++;
          } else {
            if(select_limit === 1){
              $(this).parent().children().removeClass("selected");
              $(this).addClass("selected");
            }
          }
        }

        if($(this).closest(".single-step").data("id") === "06"){
          $(this).parent().children().last().removeClass("selected");
        }
      }

      // Show Step error when there is no item selected in the step form
      var step_form = $(this).closest(".step-form");
      var step_error = step_form.next(".step-error");

      if(limit_num > 0) {
        step_error.addClass("hide");
      } else {
        step_error.removeClass("hide");
      }
    });

    // Email Recommendation Buttion Action
    $(".regime-result .action-buttons a.btn.email-recom-btn").click(function(e){
      e.preventDefault();

      var customer_name = $("#customer-name").val();
      var customer_email = $("#customer-email").val();

      const emailButtonLabel = $(this).find("[data-loader]");      
      const emailButtonLoader = $(this).find("span.label");

      emailButtonLabel.removeClass("hide");
      emailButtonLoader.addClass("hide");

      var hero_product = {
        product_img: $("#result-hero-product-html .product-single__media-wrapper img.product-featured-media").attr("src"),
        product_title: $("#result-hero-product-html h1.product-single__title").text().replace(/(\r\n|\n|\r)/gm, " ").replace(/\s+/g," ").trim(),
        product_desc: $("#result-hero-product-html .dz-oliveda-productdetails-short-description").text().replace(/(\r\n|\n|\r)/gm, "").replace(/\s+/g," ").trim(),
        product_price: $("#result-hero-product-html .price__pricing-group .price__regular dd").text().replace(/(\r\n|\n|\r)/gm, "").replace(/\s+/g," ").trim(),
        product_link: Shopify.shop + $("#result-hero-product-html .product-single__meta").attr("data-url")
      };

      var recommendation_products = [];

      if($("#regime-result-recommendation .result-recommendation-products .single-box-product").length > 0){
        $("#regime-result-recommendation .result-recommendation-products .single-box-product").each(function(index, element){
          recommendation_products.push({
            product_img: $(element).find("img.product-featured-img").attr("src"),
            product_title: $(element).find(".product-single__title").text().replace(/(\r\n|\n|\r)/gm, " ").replace(/\s+/g," ").trim(),
            product_desc: $(element).find(".product-desc").text().replace(/(\r\n|\n|\r)/gm, "").replace(/\s+/g," ").trim(),
            product_price: $(element).find(".product-price").text().replace(/(\r\n|\n|\r)/gm, "").replace(/\s+/g," ").trim(),
            product_link: Shopify.shop + $(element).find(".read-more").find("a").attr("href")
          });
        });
      }

      var recommendation_data = {
        name: customer_name,
        email: customer_email,
        hero_product: hero_product,
        recommendation_products: recommendation_products,
        all_rec_product_ids: all_rec_product_ids,
        store_url: window.top.location.href,
        store_lang: 'en'
      }

      var request = $.ajax({
        url: "https://ground.connectolive.com/regime-builder/",
        type: "post",
        data: recommendation_data,        
      });

      request.done(function (response, textStatus, jqXHR){
        console.log(response);
        emailButtonLabel.addClass("hide");
        emailButtonLoader.removeClass("hide");
      });

      // Callback handler that will be called on failure
      request.fail(function (jqXHR, textStatus, errorThrown){
      // Log the error to the console
        console.error(
          "The following error occurred: "+
          textStatus, errorThrown
        );
        emailButtonLabel.addClass("hide");
        emailButtonLoader.removeClass("hide");
      });

    });

    //Tooltip Close Button Action
    $(document).on("click", ".step-teller .tooltip .tooltip-content .close-btn", function(){
      $(this).closest(".tooltip-icon").removeClass("open").addClass("close");
      $(this).closest(".tooltip").next().removeClass("hide");
    });
    $(document).on("click", ".step-teller .tooltip-notification", function(){
      $(this).addClass("hide");
      $(this).closest(".tooltip-icon").removeClass("close").addClass("open");
    });

    //Auto add Gift Product to the cart if more than 2 recommendation products are added to the cart
    var recom_num = 0;
    
    function updateCartCount() {
        var countElement = document.querySelector(".dz-no-text-deco.fs-10.position-absolute.m-0.dz-oswald-font");
        if (countElement) {
            let currentCount = parseInt(countElement.textContent.trim(), 10) || 0;
            countElement.textContent = currentCount + 1; // Increment count
        }
    }

    
    $(document).on("click", ".single-box-product .box-product-submit-btn button", function(){
     updateCartCount();
      if(cus_gift_pur && !isConsultant){
        console.log("Retail Customer");
        auto_add_gift_product();
      }      
    });

    $(document).on("submit", "#result-hero-product .add-to-cart-button form", function(){
     updateCartCount(); 
      if(cus_gift_pur && !isConsultant){
         console.log("Retail Customer");
        auto_add_gift_product();
      } 
    });

    // Auto add Gift Product
function auto_add_gift_product() {
  recom_num++;
  console.log(recom_num);

  // Check if 2 products have been added to trigger auto-add
  if (recom_num > 1) {
    tryAutoAddGiftProduct();
  }
}

// Function to attempt to auto add the gift product
function tryAutoAddGiftProduct(retryCount = 1) {
  console.log("Attempting to auto add gift product, try:", retryCount);

  setTimeout(function () {
    $("form#result-gift-product-form").submit();

    // Check if the gift product is in the cart after submission
    setTimeout(function () {
      isGiftProductAdded()
        .then((giftProductExists) => {
          if (!giftProductExists) {
            console.log("Gift product not added. Retrying...");

            // Retry adding the gift product (up to 3 times)
            if (retryCount < 3) {
              tryAutoAddGiftProduct(retryCount + 1);
            } else {
              console.log("Failed to auto add gift product after 3 attempts.");
            }
          } else {
            console.log("Gift product successfully added to the cart.");
          }
        })
        .catch((error) => console.error('Error checking gift product:', error));
    }, 1500); // Wait 2 seconds to verify if the product is added
  }, 500); // Initial wait time before the first attempt
}

    // Function to check if the gift product is in the cart using fetch
function isGiftProductAdded() {
  return fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      if (cart.items && cart.items.length > 0) {
        const auto_add_gift_product_id = "57049817219445";
        const second_gift_product_id = "57049817219445"; // Replace with your second gift product ID

        console.log('Items in cart:', cart.items);
        console.log('Gift product ID:', auto_add_gift_product_id);

        const giftProductExists = cart.items.some(item => item.id === parseInt(auto_add_gift_product_id));
        const subtotalCents = cart.items_subtotal_price;
        const subtotalDollars = subtotalCents / 100;

        if (subtotalCents >= 5900) {
          console.log(`Cart subtotal is $${subtotalDollars}, adding second gift...`);

          // Submit another form for the second gift OR call your add logic
          const secondGiftForm = document.querySelector('form#second-gift-product-form');
         fetch('/cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  body: JSON.stringify({
    id: parseInt(second_gift_product_id),
    quantity: 1
  }),
})
.then(response => {
  if (!response.ok) {
    throw new Error("Failed to add second gift to cart.");
  }
  return response.json();
})
.then(data => {
  console.log("Second gift added to cart:", data);
})
.catch(error => {
  console.error("Error adding second gift:", error);
});
          
        } else {
          console.log(`Cart subtotal is $${subtotalDollars}, not eligible for second gift.`);
        }

        return giftProductExists;
      } else {
        console.log('Cart is empty');
        return false;
      }
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
      return false;
    });
}

    
    //Email Auto Sending Function
    function email_result_products(){
      var customer_name = $("#customer-name").val();
      var customer_email = $("#customer-email").val();
      var consent_to_consultant_email = $("#quiz-consent-email").is(":checked");

      var hero_product = {
        id: hero_product_fid,
        sup: $("#result-hero-product .product-single__title p:first-child").text(),
        primary_title: $("#result-hero-product .product-single__title p:nth-child(2)").text(),
        secondarytitle: $("#result-hero-product .product-single__title p:last-child").text(),
        hero_pricing: $("#result-hero-product .product-meta > p").html()
      };

      var gproduct = {
        id: gift_product_id,
        sup: gift_product_sup,
        stat: cus_gift_pur
      };

      var recommendation_data = {
        name: customer_name,
        email: customer_email,
        hero_product: hero_product,
        gproduct: gproduct,
        recommendation_products: rec_product_handles,
        all_rec_product_ids: all_rec_product_ids,
        recaptcha_response: $("#recaptchaResponse").val(),
        store_url: $("#regime-result-recommendation").data("store-url"),
        store_lang: 'en'
      }

     // Function to get a cookie
      function getCookie(name) {
        var nameEQ = name + "=";
        var cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length; i++) {
          var cookie = cookies[i];
          while (cookie.charAt(0) == ' ') {
            cookie = cookie.substring(1, cookie.length);
          }
          if (cookie.indexOf(nameEQ) == 0) {
            return cookie.substring(nameEQ.length, cookie.length);
          }
        }
        return null;
      }
    var enrollerinfo = JSON.parse(localStorage.getItem('enrollerinfo') || '{}') || {};
       // Retrieving the cookie
      var referralCookie = null;
      if(enrollerinfo.AssociateID)
      {
      	referralCookie = enrollerinfo.AssociateID;
      }
    
    // Only send consultant email if the user explicitly opted in
    if (consent_to_consultant_email) {
      if (referralCookie !== null && referralCookie !== undefined) {
        recommendation_data.sponsorID = referralCookie;

        var customer_phone = $("#customer-phone").val();
        recommendation_data.customer_phone = customer_phone ? customer_phone : null;

        var headers = new Headers({ 'Content-Type': 'application/json' });
        recommendation_data.consent_to_consultant_email = consent_to_consultant_email ? 1 : 0;

        var requestOptions = {
          method: 'POST',
          headers: headers,
          body: JSON.stringify(recommendation_data)
        };

        var url = 'https://mailer.connectolive.com/OliveBrainEmail';

        fetch(url, requestOptions)
          .then(function (response) {
            if (response.ok) {
              console.log('Consultant email POST successful');
            } else {
              console.error('Consultant email POST failed');
            }
          })
          .catch(function (error) {
            console.error('An error occurred:', error);
          });

      } else {
        console.error('Referral cookie not found (cannot send consultant email)');
      }
    } else {
      console.log('User did not consent to consultant email; skipping /OliveBrainEmail');
    }

  
       // Retrieving the 'referral' / webAlias cookie
      var webAliasCookie = null;
      if(enrollerinfo.WebAlias)
      {
      	webAliasCookie = enrollerinfo.WebAlias;
      }
    
    if (webAliasCookie !== null && webAliasCookie !== undefined) {
      recommendation_data.webAlias = webAliasCookie;
	  }

      var request = $.ajax({
        url: "https://mailer.connectolive.com/OliveBrain",
        type: "post",
        data: recommendation_data,
        // headers: {
        //   "accept": "application/json",
        //   "Access-Control-Allow-Origin":"*"
        // },
        dataType: "text",
      });

      request.done(function (response, textStatus, jqXHR){
        console.log(response);
      });

      // Callback handler that will be called on failure
      request.fail(function (jqXHR, textStatus, errorThrown){
      // Log the error to the console
        console.error(
          "The following error occurred: "+
          textStatus, errorThrown
        );
      });





   
    
    if (referralCookie !== null && referralCookie !== undefined) {
      recommendation_data.sponsorID = referralCookie;
       var customer_phone = $("#customer-phone").val();
        recommendation_data.customer_phone = customer_phone;
      // Create the request headers
      var headers = new Headers({
        'Content-Type': 'application/json'
      });
    
      // Create the request options
      var requestOptions = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(recommendation_data)
      };


      // Create the URL
      var url = 'https://mailer.connectolive.com/OliveBrainEmail';
    
    
    } else {
      // Handle the case where referralCookie is null or undefined
      console.error('Referral cookie not found');
    }
      
      
    }

   
    
    // Regime Builder Testimonials Slider
    function testimonial_slider(){
      if($(".regime-testimonial-list .testimonials-list").length > 0){
        $(".regime-testimonial-list .testimonials-list").slick({
          fade: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
          touchMove: false,
          focusOnSelect: true,
          dots: true,
          arrows: true,
          appendArrows: $(".slider-meta .slider-arrows"),
          prevArrow: '<span class="left-arrow"><svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.44531 10.2913L1.00087 5.64559L5.44531 0.999924" stroke="#787878"/></svg></span>',
          nextArrow: '<span class="right-arrow"><svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 10.2913L5.44444 5.64559L1 0.999924" stroke="#787878"/></svg></span>',
          appendDots: $(".slider-meta .slider-pagin"),
          customPaging: function(slick, index) {
            return '<a>' + (index + 1) + '</a>';
          }
        });
      }      
    }

   
  // Function to update button styles based on hero-stock-availabity attribute
  function updateButtonStyles() {
    const button = document.getElementById("hero-stock-availabity");
    if (!button) {
      console.log("Button not found."); // Debug log if button is not found
      return;
    }

    const stockAvailability = button.getAttribute("hero-stock-availabity");
    console.log("Button attribute value:", stockAvailability); // Debug log for attribute value

    // Check if the value is '0' and apply styles if true
    if (stockAvailability == "0") {
      console.log("Stock availability is 0. Applying styles."); // Debug log for zero value
      button.style.cursor = "default";
      button.style.backgroundColor = "black";
      button.disabled = true; 
    } 
  }

  // Function to update span text based on hero-stock-text attribute
  function updateSpanText() {
    const span = document.getElementById("hero-stock-text");
    if (!span) {
      console.log("Span not found."); // Debug log if span is not found
      return;
    }

    const stockText = span.getAttribute("hero-stock-text");
    console.log("Span attribute value:", stockText); // Debug log for attribute value

    // Check if the value is '0' and update the text to "SOLD OUT"
    if (stockText == "0") {
      console.log("Stock text is 0. Changing text to SOLD OUT."); // Debug log for zero value
      span.textContent = "SOLD OUT";
    } else {
      console.log("Stock text is not 0. No text change."); // Debug log for other values
    }
  }



    
    function treebrain_comments_slider(){
      $(".treebrain-comments .treebrain-comments-list .comments-list").slick({
        fade: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        focusOnSelect: true,
        dots: false,
        arrows: false
      }); 
    }

    function treebrain_comments_slider_destroy(){
      $(".treebrain-comments .treebrain-comments-list .comments-list").slick('unslick');
    }
    
    function validate_current_step(step){
      var $return = false;
      var $step_form = $('.regime-steps .single-step[data-id="'+ step +'"]').find(".step-form");

      if($step_form){
        var $step_option = $step_form.find("input").length > 0 ? $step_form.find("input") : $step_form.find(".select-list");
        
        if($step_option.hasClass("select-list")){
          $($step_option.children()).each(function(){
            if($(this).hasClass("selected")) $return = true;
          });
        } else {
          if($step_option.attr("id") === "customer-email"){
            var step_customer_email = $step_option.val();
            
            if(step_customer_email){
              if(wbkCheckEmail(step_customer_email)) $return = true;
            }
            
          } else {
            if($step_option.val()) $return = true;
          }
        }
        
        if($step_form.next(".step-error").length > 0){      
          if($return){
            $step_form.next(".step-error").addClass("hide");
          } else {
            $step_form.next(".step-error").removeClass("hide");
          }
        }
      }
      
      return $return;
    }
    
    function step_bar_update(step){
      var step_class= "",
          $step_num = $(".step-bar .step-num");
      switch(step){
        case "01":
          step_class= "step-one";
          break;
        case "02":
          step_class= "step-two";
          break;
        case "03":
          step_class= "step-three";
          break;
        case "04":
          step_class= "step-four";
          break;
        case "05":
          step_class= "step-five";
          break;
        case "06":
          step_class= "step-six";
          break;
        case "07":
          step_class= "step-seven";
          break;
        case "08":
          step_class= "step-eight";
          break;
        case "09":
          step_class= "step-nine";
          break;
        default:
          step_class= "step-ten";
      }
      
      if(parseInt(step) > 0){
        $step_num.removeClass().addClass("step-num").addClass(step_class);
        $step_num.text(step);
      }
      
    }
    
    function step_tooltip_update(step){

      $(".regime-footer .step-teller").removeClass("hide");

      //Second Step ToolTip
      $('.regime-steps .single-step[data-tooltip*="#name#"]').attr("data-tooltip", function(i, original){
        return original.replace("#name#", cust_name);
      });

      var step_tooltip = $('.regime-steps .single-step[data-id="'+ step +'"]').data("tooltip");

      if(step === '08'){
        step_tooltip += " " + cust_name + ".";
      }

      if(step === '010'){
        step_tooltip = $('.result-page-tooltip').data("tooltip");
      }
      $(".regime-footer .step-teller .tooltip .tooltip-content p").text(step_tooltip);
      if(step_tooltip == ""){
        $(".regime-footer .step-teller .tooltip-icon").removeClass("open").addClass("close");
        $(".regime-footer .step-teller .tooltip-notification").addClass("hide");
      } else {
        $(".regime-footer .step-teller .tooltip-icon").removeClass("close").addClass("open");
      }
    }
    
    // SMOOTH SCROLL TO ANCHOR        
    function scroll_to_anchor(anchor){
      var target = $("#" + anchor);
      var headerHeight = $('.header').outerHeight(true);
      $('html, body').animate({
        scrollTop: target.offset().top - headerHeight
      }, 1000);
    }

    function removeDuplicates(arr) {
      return arr.filter((item,
          index) => arr.indexOf(item) === index);
    }

    // check email
    function wbkCheckEmail( val ) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if ( val == '' || !re.test(val) ){
          return false;
      }
      return true;
    }
  });
  
})(jQuery, this);